import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsVmwareComponent } from './simple-icons-vmware.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsVmwareComponent ],
    exports:      [ SimpleIconsVmwareComponent ],
    bootstrap:    []
})
export class SimpleIconsVmwareModule {}
